import { BenefitType } from '../types';
import {
  gradientConfigFromJson,
  gradientConfigToCss,
} from './gradientMobileUtils';
import {
  convertNicknameEffectForForm,
  convertNicknameEffectForSubmit,
} from './gradientUtils';

/**
 * 将后端返回的 typeLimit 值转换为表单可用的格式
 * @param typeLimitValue 后端返回的 typeLimit 值
 * @param type 会员权益类型
 * @returns 表单可用的 typeLimit 值
 */
export const convertTypeLimitForForm = (
  typeLimitValue: string | number | undefined,
  type: BenefitType
): string | number => {
  if (!typeLimitValue) {
    return '';
  }

  const valueStr = typeLimitValue.toString();

  switch (type) {
    case BenefitType.NICKNAME:
      // 昵称类型：将后端返回的值转换为表单可用的格式
      return convertNicknameEffectForForm(valueStr);

    case BenefitType.FREE_GENERATION:
    case BenefitType.HD_DOWNLOAD:
    case BenefitType.EXPOSURE:
    case BenefitType.SPEED_BOOST:
    case BenefitType.MULTI_IMAGE:
      // 这些类型：typeLimit 存储数值
      const numValue = Number(valueStr);
      return !isNaN(numValue) ? numValue : valueStr;

    case BenefitType.AVATAR_FRAME:
    case BenefitType.EXCLUSIVE_STYLE:
    case BenefitType.OTHER:
    default:
      // 这些类型：typeLimit 存储字符串
      return valueStr;
  }
};

/**
 * 将表单的 typeLimit 值转换为提交格式
 * @param typeLimitValue 表单的 typeLimit 值
 * @param type 会员权益类型
 * @returns 提交用的 typeLimit 值（字符串格式）
 */
export const convertTypeLimitForSubmit = (
  typeLimitValue: string | number | undefined,
  type: BenefitType
): string => {
  if (typeLimitValue === undefined || typeLimitValue === null) {
    return '';
  }

  switch (type) {
    case BenefitType.NICKNAME:
      // 昵称类型：将表单的值转换为后端提交格式
      if (typeof typeLimitValue === 'string') {
        return convertNicknameEffectForSubmit(
          typeLimitValue,
          gradientConfigFromJson,
          gradientConfigToCss
        );
      }
      return '';

    case BenefitType.FREE_GENERATION:
    case BenefitType.HD_DOWNLOAD:
    case BenefitType.EXPOSURE:
    case BenefitType.SPEED_BOOST:
    case BenefitType.MULTI_IMAGE:
      // 这些类型：转换为字符串
      return String(typeLimitValue);

    case BenefitType.AVATAR_FRAME:
    case BenefitType.EXCLUSIVE_STYLE:
    case BenefitType.OTHER:
    default:
      // 这些类型：已经是字符串，直接使用
      return typeLimitValue?.toString() || '';
  }
};

